export default __webpack_public_path__ + "static/media/closeIcon.9534cc66.svg";